import { CountryInfo } from 'pages/insights-pro/marketplace-tab/model';
import { Measure } from 'services/model/model.service';
import { PaginatedAccordionList } from 'pages/insights-pro/common/components/PaginatedAccordionList';
import { EmptyState } from 'components/EmptyState';

interface ActiveMarketplacesPerCountryProps {
  qtyMeasure: Measure;
  gmvMeasure: Measure;
  countries: CountryInfo[];
}

export function ActiveMarketplacesPerCountry({ qtyMeasure, gmvMeasure, countries }: ActiveMarketplacesPerCountryProps) {
  if (countries.length === 0) {
    return <EmptyState />;
  }

  return (
    <PaginatedAccordionList
      items={countries.filter(c => c.marketplaces.some(m => qtyMeasure.getValue(m.entry?.values) > 0))}
      getId={c => `country-${c.name}`}
      getTitle={c => c.name}
      getBadgeCount={c => c.marketplaces.filter(m => qtyMeasure.getValue(m.entry?.values) > 0).length}
      getChildrenItems={c =>
        c.marketplaces
          .filter(m => qtyMeasure.getValue(m.entry?.values) > 0)
          .sort((a, b) => gmvMeasure.getValue(b.entry?.values) - gmvMeasure.getValue(a.entry?.values))
          .map((m, i, arr) => (
            <div key={m.name} className="flex flex-col items-center text-nowrap" title={m.name}>
              {i === arr.length - 1 ? m.name : `${m.name} |`}
            </div>
          ))
      }
      childrenLimit={4}
      accordionItemLimit={3}
    />
  );
}
